export const SET = 'purchase-order/SET';
export const CLEAR_PAGE_DATA = 'billing/CLEAR_PAGE_DATA';
